import * as React from 'react';
import { defaultTheme, ThemeProvider } from '@samc/react-ui-theme';
import { SchedulerInput as _SchedulerInput } from '@samc/querybuilder';

export const SchedulerInput = ({ defaultValue, timeZone, onChange }) => {

    return (
        <ThemeProvider value={defaultTheme}>
        <_SchedulerInput defaultValue={defaultValue} timeZone={timeZone} onChange={onChange} />
        </ThemeProvider>
    );
}